import { useState } from "react";
import { post } from "../networking/RequestService";
import useProfilKaydet from "./useProfilKaydet";

const useGetEsListe = (handlePopit, linkedinUrl) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [showEsListe, setShowEsListe] = useState(false);
    const { profilKaydet } = useProfilKaydet();

    const getEsListe = async (params, redirectToProfile = false) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "profilEsListe",
                ad: params.fullName ? params.fullName : params.ad + " " + params.soyad,
                baslik: params.baslik,
                sirket: params.sirket,
                email: params.email,
            };

            const response = await post(payload);

            if (response && response.data) {
                const profilListe = [...response.data.profilBenzerListe, ...response.data.profilEsListe];

                setData({ profilListe });

                if (response.data.profilEsListe?.length === 0 && response.data.profilBenzerListe?.length === 0) {
                    const nameAndSurname = params.fullName ? params?.fullName.split(" ") : [];
                    const name = nameAndSurname
                        .slice(0, nameAndSurname.length - 1)
                        .join(" ")
                        .trim();
                    const surname = nameAndSurname.length > 1 ? nameAndSurname[nameAndSurname.length - 1].trim() : "";

                    const cityAndCountry = params?.cityAndCountry ? params?.cityAndCountry.split(", ") : [];
                    const city =
                        cityAndCountry.length > 1
                            ? cityAndCountry
                                  .slice(0, cityAndCountry.length - 1)
                                  .join(", ")
                                  .trim()
                            : "";
                    const country =
                        cityAndCountry.length > 1
                            ? cityAndCountry[cityAndCountry.length - 1].trim()
                            : params?.cityAndCountry;

                    const result = await profilKaydet({
                        ad: params.fullName ? name : params.ad,
                        soyad: params.fullName ? surname : params.soyad,
                        baslik: params.baslik,
                        headline: params.headline,
                        sirket: params.sirket,
                        email: params.email,
                        tel: params.tel,
                        country: params.cityAndCountry ? country : params.country,
                        city: params.cityAndCountry ? city : params.city,
                        resim: params.resim,
                        url: params.url,
                        kategori: params.kategori ? params.kategori : "lead",
                    });
                    if (result.profil.id && redirectToProfile) {
                        handlePopit(result.profil.id, params.url);
                        // history.push(`/extension?profileId=${result.profil.id}`);
                    }
                }

                return profilListe;
            }

            return [];
        } catch (err) {
            setError(err);
            return [];
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        profilListe: data,
        getEsListe,
        showEsListe,
        setShowEsListe,
    };
};

export default useGetEsListe;
